module.exports = require("./fr-PF.js");